//#region src/changeset_type.ts
var ChangesetType = /* @__PURE__ */ function(ChangesetType) {
	ChangesetType["MagicCopy"] = "magic-copy";
	return ChangesetType;
}(ChangesetType || {});
//#endregion
export { ChangesetType };

//# sourceMappingURL=changeset_type.js.map